import React from 'react';
import { useTranslation } from 'react-i18next';

const Footer = () => {

    const { t } = useTranslation();

    return (
        <footer className="page-footer footer footer-static footer-dark pink darken-4 gradient-shadow navbar-border navbar-shadow">
            <div className="footer-copyright">
                <div className="container">
                    <span>&copy; {(new Date()).getFullYear()} <a href="https://www.insconsfa.com/" target="_blank" rel="noopener noreferrer">Insconsfa</a> { t('footer_allrights') }.</span>
                </div>
            </div>
        </footer>
    );

};

export default Footer;